import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SidebarService } from 'src/services/sidebar.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  currentPath: string | undefined;
  @Input() isExpanded: boolean = true;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private sidebarService: SidebarService) { }

  ngOnInit(): void {
  }
  logout() {
    localStorage.clear()
    window.location.href = '/login';
  }

  handleSidebarToggle = () => this.toggleSidebar.emit(!this.isExpanded);

}
